<script lang="ts">
  interface Props {
    transactionAmount: number;
    currencyName: string;
  }

  let { transactionAmount, currencyName }: Props = $props();

  const imageSrc = `/currencies/${currencyName?.toLowerCase()}.png`;
</script>

<div class="flex gap-2 items-center justify-center">
  <img src={imageSrc} width="32" />
  <h3>{transactionAmount} {currencyName}</h3>
</div>